/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_Models_TopInputs */

const en_mk_mx_models_top = /** @type {(inputs: Mk_Mx_Models_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top-tier models for heavy reasoning`)
};

const id_mk_mx_models_top = /** @type {(inputs: Mk_Mx_Models_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model kelas atas untuk penalaran berat`)
};

/**
* | output |
* | --- |
* | "Top-tier models for heavy reasoning" |
*
* @param {Mk_Mx_Models_TopInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_models_top = /** @type {((inputs?: Mk_Mx_Models_TopInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_Models_TopInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_models_top(inputs)
	return en_mk_mx_models_top(inputs)
});